import { useTranslation } from 'react-i18next';
import ChevronIcon from '../../assets/icons/chevron.svg?react';
import styles from './PatientDetailsDrawer.module.css';

interface PatientDrawerHeaderProps {
  /** Carried by the title element, so the shell can name the dialog after it. */
  titleId: string;
  title: string;
  /** Supplied only when there is a layer to go back to; omitted renders no button. */
  onBack?: () => void;
}

export const PatientDrawerHeader = ({ titleId, title, onBack }: PatientDrawerHeaderProps) => {
  const { t } = useTranslation();

  const heading = (
    <span className={styles.drawerTitle} id={titleId}>
      {title}
    </span>
  );

  if (!onBack) return heading;

  return (
    <div className={styles.patientHeader}>
      <button className={styles.backButton} onClick={onBack} aria-label={t('go-back')}>
        <span className={styles.backIcon}>
          <ChevronIcon />
        </span>
      </button>
      {heading}
    </div>
  );
};
